import styled from 'styled-components'
import { variant } from 'styled-system'

import { Flex } from '@/atoms/layout'
import { AdornmentPosition } from '@/models/common'

const AdornmentPositions = variant({
  prop: '$adornmentPosition',
  variants: {
    [AdornmentPosition.START]: {
      left: 0,
    },
    [AdornmentPosition.END]: {
      right: 0,
    },
  },
})

export const InputAdornment = styled(Flex)<{ $adornmentPosition?: AdornmentPosition }>`
  position: absolute;
  bottom: 30%;
  align-items: center;
  justify-content: center;
  font-family: ${({ theme }) => theme.fonts.textCondensedFont};
  font-size: 1rem;
  line-height: 1.1875em;
  color: ${({ theme }) => theme.colors.greyLight};

  &:hover {
    svg > g > path,
    svg > path {
      fill: ${({ theme }) => theme.colors.grey};
    }
  }

  svg > g > path,
  svg > path {
    fill: ${({ theme }) => theme.colors.greyLight};
  }

  ${AdornmentPositions}
`
